import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { login } from "../../api/apiUser.js";
import { useHistory } from "react-router-dom";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  }
};

const useStyles = makeStyles(styles);

export default function Login() {
  const history = useHistory(); // Initialize useHistory hook

  const classes = useStyles();

  const [loginFormData, setLoginFormData] = useState({
    Korisnicko_ime: "",
    Lozinka: "",
  });

  const handleChange = (e) => {
    const name = e.target.id;
    const value = e.target.value;
    setLoginFormData({
      ...loginFormData,
      [name]: value,
    });
  };

  const handleLogin = async () => {
    try {
      const results = await login(loginFormData);
      if (results) {
        history.push("/admin/dashboard");
      } else alert("Pogrešno korisničko ime ili lozinka! Pokušajte ponovo.");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Prijava</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Korisničko ime"
                    id="Korisnicko_ime"
                    value={loginFormData.Korisnicko_ime}
                    onChange={handleChange}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <br />
                <br />
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Lozinka"
                    id="Lozinka"
                    value={loginFormData.Lozinka}
                    type="password"
                    onChange={handleChange}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter className={classes.centerElement}>
              <Button color="success" onPress={handleLogin}>
                Prijava
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
